import { Grid, Typography } from "@material-ui/core"
import { PoolRefundPolicy } from "../../constants/pool"
import { useEffect, useState } from "react"

interface DesktopRefundInfoProps {
  poolRefundPolicy?: PoolRefundPolicy
  poolTgeDate?: Date
}


const DesktopRefundInfo = (props: DesktopRefundInfoProps) => {

  const [refundStartDate, setRefundStartDate] = useState<Date | null>(null);
  const [refundEndDate, setRefundEndDate] = useState<Date | null>(null);

  const [isRefundLive, setIsRefundLive] = useState(false);
  const [isRefundWindowExpired, setIsRefundWindowExpired] = useState(false);

  useEffect(() =>{
    console.info(props.poolTgeDate && new Date(props.poolTgeDate).getTime())
    if (props.poolTgeDate && props.poolRefundPolicy?.explicitRefundWindowInSeconds) {
      setRefundStartDate(new Date(props.poolTgeDate))
      setRefundEndDate(new Date(new Date(props.poolTgeDate).getTime() + props.poolRefundPolicy?.explicitRefundWindowInSeconds * 1000))
    }
  }, []);

  useEffect(() => {
    if (refundStartDate && refundEndDate) {
      const now = new Date();
      setIsRefundLive(now >= refundStartDate && now <= refundEndDate)
      setIsRefundWindowExpired(now > refundEndDate)
    }
  }, [refundStartDate, refundEndDate])

  return (
    <>
      <Grid container>
        <Grid item>
          <Typography variant="subtitle1" component="div" style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>Refundable: <Typography color={ isRefundWindowExpired ? "error" : props?.poolRefundPolicy?.refundable ? "primary" : "error"} variant="subtitle1">{ isRefundWindowExpired ? "Expired" : props?.poolRefundPolicy?.refundable ? "YES" : "NO" }</Typography></Typography>
        </Grid>
        {
          props?.poolRefundPolicy?.refundable && (
            <>
              <Grid item>
                <Typography variant="subtitle1" component="div" style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>Refund Start Date: <Typography variant="subtitle1" color="primary">{isRefundLive ? 'The refund is currently live.' : refundStartDate?.toUTCString
                ()}</Typography></Typography>
              </Grid>
              <Grid item>
              <Typography variant="subtitle1" component="div" style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>Refund End Date: <Typography variant="subtitle1" color={ isRefundWindowExpired ? 'error' : 'primary'}>{refundEndDate?.toUTCString()}</Typography></Typography>
              </Grid>
            </>
          )
        }
      </Grid>
    </>
  )
}

export default DesktopRefundInfo